import { useEffect, useState } from "react";
import { X, Clock } from "lucide-react";

export default function AddSlotModal({ day, onClose, onAdd }) {
    const [start, setStart] = useState("09:00");
    const [end, setEnd] = useState("10:00");
    const [error, setError] = useState("");

    useEffect(() => {
        if (day) {
            setStart("09:00");
            setEnd("10:00");
            setError("");
        }
    }, [day]);

    if (!day) return null;

    const handleAdd = () => {
        if (start >= end) {
            setError("End time must be after start time.");
            return;
        }
        onAdd(day, start, end);
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">
            <div className="w-full max-w-sm rounded-2xl bg-white shadow-xl border border-slate-200">
                <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
                    <p className="font-medium text-slate-900 text-sm flex items-center gap-1.5">
                        <Clock className="h-4 w-4 text-indigo-500" />
                        Add slot · {day}
                    </p>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
                        <X className="h-4.5 w-4.5" />
                    </button>
                </div>

                <div className="px-5 py-4 space-y-3">
                    <div>
                        <label className="block text-xs font-medium uppercase tracking-wide text-slate-500 mb-1.5">
                            Start time
                        </label>
                        <input
                            type="time"
                            value={start}
                            onChange={(e) => setStart(e.target.value)}
                            className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm text-slate-700 outline-none focus:border-indigo-300 focus:ring-2 focus:ring-indigo-100 transition"
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-medium uppercase tracking-wide text-slate-500 mb-1.5">
                            End time
                        </label>
                        <input
                            type="time"
                            value={end}
                            onChange={(e) => setEnd(e.target.value)}
                            className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm text-slate-700 outline-none focus:border-indigo-300 focus:ring-2 focus:ring-indigo-100 transition"
                        />
                    </div>
                    {error && <p className="text-xs text-red-500">{error}</p>}
                </div>

                <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-slate-100">
                    <button
                        onClick={onClose}
                        className="rounded-lg px-3.5 py-2 text-xs font-medium text-slate-600 hover:bg-slate-100 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleAdd}
                        className="rounded-lg bg-indigo-600 px-3.5 py-2 text-xs font-medium text-white hover:bg-indigo-700 transition-colors"
                    >
                        Add slot
                    </button>
                </div>
            </div>
        </div>
    );
}